import { useCallback, useEffect, useState } from 'react';
import { BalanceCreditInfoApiResponse } from 'src/types/Balance';
import { fetchBalanceCreditInfo as fetchBalanceCreditInfoFromApi } from 'src/components/selfService/common/Balance/api/fetchBalanceCreditInfo';

export type UseFetchBalanceCreditInfoReturnType = {
  isLoading: boolean;
  hasError: boolean;
  balanceCreditInfo: BalanceCreditInfoApiResponse | null;
  fetchBalanceCreditInfo: () => Promise<void>;
};

export const useFetchBalanceCreditInfo = (
  externalBalanceBuyerId: string | null
): UseFetchBalanceCreditInfoReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [balanceCreditInfo, setBalanceCreditInfo] =
    useState<BalanceCreditInfoApiResponse | null>(null);

  const fetchBalanceCreditInfo = useCallback(async (): Promise<void> => {
    if (!externalBalanceBuyerId) {
      return;
    }

    try {
      setIsLoading(true);
      setHasError(false);

      const response = await fetchBalanceCreditInfoFromApi(
        externalBalanceBuyerId
      );
      setBalanceCreditInfo(response);
    } catch (error) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [externalBalanceBuyerId]);

  useEffect(() => {
    fetchBalanceCreditInfo();
  }, [externalBalanceBuyerId, fetchBalanceCreditInfo]);

  return {
    isLoading,
    hasError,
    balanceCreditInfo,
    fetchBalanceCreditInfo,
  };
};
